import { useEffect } from "react";
import classes from "./transaction-history-container.module.css";
import { useRouter } from "next/router";
import Refresh from "./Refresh";
import { createNumbersArray, isMobileDevice } from "../../services/utils";
import AvailableCredits from "./AvailableCredits";
import Filters from "./Filters";
import TransactionTable from "./TransactionTable";
import TransactionHistoryStore from "../../zustandStores/TransactionHistoryStore";
import NewPagination from "../NewPagination/index";
import { Routes } from "../../routes/RouteConstants";
import TransactionMobileCards from "./TransactionMobileCards";
import ReservedCreditsLabel from "./ReservedCreditsLabel";
import LogService from "../../services/LogService";
import CREDIT_EVENTS from "../../utils/CreditEvents";
import {
  ALL_TRANSACTIONS,
  modalStateValues,
  modalType
} from "../../services/constants";
import useCreditProfileStore from "../../zustandStores/userCreditProfileStore";
import InvoiceEmailModal from "components/InvoiceEmailModal";
import useModalStore from "zustandStores/useModalStore";

function TransactionHistory(props) {
  const { isReservedTab, onRefresh } = props;
  const router = useRouter();
  const { query } = router;
  const { tabId = ALL_TRANSACTIONS, page: currentPage = 1 } = query;

  const { data } = TransactionHistoryStore(state => ({
    data: state.data
  }));

  const { creditData, showExpiringCredits } = useCreditProfileStore(state => ({
    creditData: state.data,
    showExpiringCredits: state.showExpiringCredits
  }));

  useEffect(() => {
    if (!data?.transactionData?.length) {
      LogService.log(CREDIT_EVENTS.TH_NO_TRANSACTION_LANDED);
    }
  }, []);

  useEffect(() => {
    LogService.log(CREDIT_EVENTS.TRANSACTION_HISTORY_LANDED, {
      trackSource: true,
      reservedCredits: creditData.holdCredits,
      showExpiringCredits: !!showExpiringCredits
    });
  }, []);

  const headerData = [
    {
      label: "Transaction",
      class: classes.transactionHeader
    },
    {
      label: "Credits",
      class: classes.cellHeader
    },
    {
      label: "Status",
      class: classes.cellHeader
    },
    {
      label: "Date",
      class: classes.cellHeader
    },
    {
      label: "Closing Balance",
      class: classes.balanceHeader
    },
    {
      label: "Invoice",
      class: classes.cellHeader
    }
  ];

  const reservedHeaderData = [
    {
      label: "Job details",
      class: classes.jobDetailsHeader
    },
    {
      label: "Credits Reserved",
      class: classes.cellHeader
    },
    {
      label: "Status",
      class: classes.cellHeader
    },
    {
      label: "Job posting date",
      class: classes.cellHeader
    }
  ];

  function onPageSelect({ page }) {
    const queryParams = { ...query, page };
    router.push({
      pathname: Routes.TRANSACTION_HISTORY,
      query: queryParams
    });
    LogService.log(CREDIT_EVENTS.TH_PAGE_CLICKED, { page });
  }

  const { modalData, setModalData } = useModalStore(state => ({
    modalData: state.modalData,
    setModalData: state.setModalData
  }));

  const isInvoiceEmailModalOpen =
    modalData?.type === modalType.INVOICE_EMAIL_MODAL &&
    modalData?.state === modalStateValues.open;

  const matchingTab = data?.tabs?.find(tab => tab.id === tabId);
  const totalCount = matchingTab?.count ?? 0;
  const itemsPerPage = 10;
  const totalPages = Math.ceil(totalCount / itemsPerPage);
  const pagesArray = createNumbersArray(totalPages);
  const pages = pagesArray.map(page => {
    return {
      page: page + 1,
      is_active: currentPage ? page === currentPage - 1 : page === 0
    };
  });
  const paginatedURLs = {
    first_page_url: null,
    last_page_url: {
      page: pagesArray.length,
      is_active: Number(currentPage) === pagesArray.length
    },
    pages
  };
  const showFilters = data?.transactionData?.length > 0;
  const isMobile = isMobileDevice();

  const handleInvoiceEmailModalClose = () => {
    setModalData({
      state: modalStateValues.CLOSE,
      type: ""
    });
  };
  return (
    <>
      <div className={classes.root}>
        {!isMobile ? (
          <div className={classes.heading}>
            <div className={classes.title}>
              {isReservedTab ? "Reserved Credits" : "Transaction History"}
            </div>
            {!isReservedTab && <Refresh onRefresh={onRefresh} />}
          </div>
        ) : null}
        <AvailableCredits isReservedTab={isReservedTab} />
        {isReservedTab && <ReservedCreditsLabel />}
        <div>
          {showFilters && !isReservedTab ? (
            <Filters dateFilter={data.dateFilter} tabs={data?.tabs} />
          ) : null}
          {isMobileDevice() ? (
            <TransactionMobileCards
              transactionData={data.transactionData}
              isReservedTab={isReservedTab}
            />
          ) : (
            <TransactionTable
              transactionData={data.transactionData}
              isReservedTab={isReservedTab}
              headerData={isReservedTab ? reservedHeaderData : headerData}
              showFilters={showFilters}
            />
          )}
        </div>
        {totalCount > itemsPerPage && (
          <NewPagination
            paginatedData={paginatedURLs}
            onPageSelect={onPageSelect}
            currentPage={currentPage}
          />
        )}
        {isInvoiceEmailModalOpen && (
          <InvoiceEmailModal
            isOpen={isInvoiceEmailModalOpen}
            onClose={handleInvoiceEmailModalClose}
          />
        )}
      </div>
    </>
  );
}

export default TransactionHistory;
